import { JmApi } from "../jm-api/jm-api";
import { TRANSPORT_LEG_COUNT_URL } from "../config/urls";

/**
 * Service for transport-related API operations
 */
export class TransportService {
  /**
   * Get leg count for specific transport and path
   * @param pathId Path identifier
   * @param routeTransport Transport mode
   * @returns Promise with leg count number
   */
  static async getLegCount(
    pathId: number,
    routeTransport: string,
  ): Promise<number> {
    const url = `${TRANSPORT_LEG_COUNT_URL}?path_id=${pathId}&route_transport=${encodeURIComponent(routeTransport)}`;

    try {
      const response = (await JmApi.get(url)) as any;
      return response?.leg_count || 0;
    } catch (error) {
      console.error("Error fetching leg count:", error);
      return 999; // Return high number to filter out problematic routes
    }
  }
}
